// extracted by mini-css-extract-plugin
export default {"defaultContainer":"defaultContainer___LD2bL","mediumContainer":"mediumContainer___AsWsO","largeContainer":"largeContainer___x7FNa"};